import React from 'react';
import LogIn from '../../components/sign-in';

const LogInPage = () => {
    return (
        <div>
            <LogIn />

        </div>
    )
}

export default LogInPage;